import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';

@Component({
  selector: 'app-content-view-modal',
  templateUrl: './content-view-modal.component.html',
  styleUrls: ['./content-view-modal.component.scss']
})
export class ContentViewModalComponent implements OnInit {
  @Input() Title: any;
  @Input() content: any;
  modalRef: any;
  @ViewChild('bankFrom') bankFromTemplate: TemplateRef<any>;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Input() isDataArray: any = false;
  constructor(
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,) { }

  ngOnInit() {
    this.modalRef = this.modalService.open(this.bankFromTemplate);
  }

  getHtmlWithLineBreaks() {
    const sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(
      this.content && this.content.replace(/\n/g, '<br>')
    );
    return sanitizedHtml;
  }

  onCloseClick() {
    this.modalRef.close()
    this.onClose.emit(true)
  }

}
